<template>
  <state-overlay :open="!!kind" :title="kind === 'server' ? 'اتصال به سامانه برقرار نشد' : 'اتصال اینترنت برقرار نیست'">
    <div class="iconcircle warn">
      <base-icon :name="kind === 'server' ? 'alert' : 'wifi-off'" />
    </div>

    <template v-if="kind === 'server'">
      <h2>اتصال به سامانه برقرار نشد</h2>
      <p>
        اینترنت شما وصل است، اما پاسخی از سرور قوه‌قضاییه دریافت نشد. ممکن است سرویس موقتاً
        در دسترس نباشد؛ چند لحظه بعد دوباره تلاش کنید. اگر <b>فیلترشکن یا VPN</b> روشن است،
        خاموش کردن آن نیز می‌تواند مؤثر باشد.
      </p>
    </template>
    <template v-else>
      <h2>اتصال اینترنت برقرار نیست</h2>
      <p>
        به‌نظر می‌رسد دستگاه شما به اینترنت متصل نیست. لطفاً اتصال Wi‑Fi یا داده‌ی همراه را
        بررسی کنید و سپس دوباره تلاش کنید.
      </p>
    </template>

    <div class="reassure">
      <base-icon name="check" />
      <span>نگران نباشید؛ اطلاعات واردشده ذخیره شده است. با برقراری اتصال، از همین مرحله ادامه می‌دهید.</span>
    </div>

    <template #foot>
      <button class="btn btn-primary" type="button" :disabled="busy" @click="$emit('retry')">
        <base-icon name="refresh" />
        <span>{{ busy ? "در حال بررسی…" : "تلاش مجدد" }}</span>
      </button>
      <button class="btn btn-outline" type="button" @click="$emit('back')">بازگشت به بازبینی</button>
    </template>
  </state-overlay>
</template>

<script>
import StateOverlay from "./StateOverlay.vue";
import BaseIcon from "./BaseIcon.vue";

/**
 * Shown when a submit could not reach the backend.
 *
 * The two variants exist because the remedies are different, and a single "connection
 * failed" message would send half the users to check a Wi-Fi connection that is fine.
 * `server` means the internet is up but the judicial API did not answer at all. A VPN is
 * one cause of that and not the only one, so the copy suggests it rather than asserting
 * it — an outage blamed on the user's VPN is advice they cannot act on.
 *
 * This dialog is only for a request that never got a reply. A backend that answers with
 * an error is not a connectivity problem and is handled on the complete screen.
 *
 * Nothing is discarded here: the reassurance line is literally true, and the captured
 * artefacts are still in the store and IndexedDB when the retry succeeds.
 */
export default {
  name: "NetworkErrorDialog",
  components: { StateOverlay, BaseIcon },

  props: {
    /** null | "offline" | "server" */
    kind: {
      type: String,
      default: null,
      validator: (value) => value === null || ["offline", "server"].indexOf(value) !== -1,
    },
    busy: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.iconcircle {
  margin: 0 auto;
}

p >>> b,
p b {
  color: var(--foreground);
}

.reassure {
  display: flex;
  gap: 9px;
  align-items: flex-start;
  background: var(--success-soft);
  color: var(--success);
  border-radius: 13px;
  padding: 11px 13px;
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.7;
  text-align: right;
  width: 100%;
  box-sizing: border-box;
  margin-top: 4px;
}

.reassure >>> svg {
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
  margin-top: 2px;
}
</style>
